import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Categoria`

export function buscarPorId(idCategoriaPadre) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idCategoriaPadre}`)
}

export function buscarMetadato(idCategoria) {
  return http.get(`${API_ENDPOINT}/BuscarMetadato/${idCategoria}`)
}

export function buscarAtributos(idCategoria) {
  return http.get(`${API_ENDPOINT}/BuscarAtributos/${idCategoria}`)
}
